/**
 * Persist structure archives on earlier supplier packages so a later RFQ
 * is the only place those structures still ask for a quote.
 */
import { arrayRemove, arrayUnion, doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from './firebase';

export async function archivePackageStructureIds(
  packageIds: readonly string[],
  structureIds: readonly string[],
): Promise<void> {
  const ids = structureIds.map((id) => id.trim()).filter(Boolean);
  const pkgs = packageIds.map((id) => id.trim()).filter(Boolean);
  if (!ids.length || !pkgs.length) return;
  await Promise.all(
    pkgs.map((packageId) =>
      updateDoc(doc(db, 'rfqPackages', packageId), {
        archivedStructureIds: arrayUnion(...ids),
        updatedAt: Timestamp.now(),
      }),
    ),
  );
}

export async function restorePackageStructureIds(
  packageIds: readonly string[],
  structureIds: readonly string[],
): Promise<void> {
  const ids = structureIds.map((id) => id.trim()).filter(Boolean);
  const pkgs = packageIds.map((id) => id.trim()).filter(Boolean);
  if (!ids.length || !pkgs.length) return;
  await Promise.all(
    pkgs.map((packageId) =>
      updateDoc(doc(db, 'rfqPackages', packageId), {
        archivedStructureIds: arrayRemove(...ids),
        updatedAt: Timestamp.now(),
      }),
    ),
  );
}
